import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../app/store';

export enum RanchAreaEnum {
  blockInfoArea = 'blockInfoArea',
  chartArea = 'chartArea',
  mapArea = 'mapArea',
  imageArea = 'imageArea',
  scansArea = 'scansArea',
  timelineArea = 'timelineArea',
}

export enum YieldAndInfoPanelsEnum {
  BlockInfo = 'blockInfo',
  PredictYield = 'predictYield',
}

export enum RanchPageViewEnum {
  ranchSummary = 'ranchSummary',
  blockDetail = 'blockDetail',
  scansPage = 'scansPage',
}

interface RanchState {
  focusedArea: RanchAreaEnum | null;
  currYieldAndInfoPanel: YieldAndInfoPanelsEnum;
  isLoadingCustomerSummary: boolean;
  ranchPageView: RanchPageViewEnum;
}

const initialState: RanchState = {
  focusedArea: null,
  currYieldAndInfoPanel: YieldAndInfoPanelsEnum.BlockInfo,
  isLoadingCustomerSummary: false,
  ranchPageView: RanchPageViewEnum.ranchSummary,
};

export const ranchState = createSlice({
  name: 'ranchState',
  initialState,
  reducers: {
    initRanchState: () => initialState,
    setRanchFocusArea: (state, action: PayloadAction<RanchAreaEnum | null>) => {
      state.focusedArea = action.payload;
    },
    setCurrYieldAndInfoPanel: (
      state,
      action: PayloadAction<YieldAndInfoPanelsEnum>
    ) => {
      state.currYieldAndInfoPanel = action.payload;
    },

    setIsLoadingCustomerSummary: (state, action: PayloadAction<boolean>) => {
      state.isLoadingCustomerSummary = action.payload;
    },
    setRanchPageView: (state, action: PayloadAction<RanchPageViewEnum>) => {
      state.ranchPageView = action.payload;
    },
  },
});

export const {
  initRanchState,
  setRanchFocusArea,
  setCurrYieldAndInfoPanel,
  setIsLoadingCustomerSummary,
  setRanchPageView,
} = ranchState.actions;

export const selectRanchFocusArea = (state: RootState) =>
  state.ranch.focusedArea;
export const selectCurrentYieldAndInfoPanel = (state: RootState) =>
  state.ranch.currYieldAndInfoPanel;
export const selectIsLoadingCustomerSummary = (state: RootState) =>
  state.ranch.isLoadingCustomerSummary;
export const selectRanchPageView = (state: RootState) =>
  state.ranch.ranchPageView;

export const selectAllRanchState = (state: RootState) => state.ranch;

export default ranchState.reducer;
